
export default function getScript (source, asyncLoad = true, defer = false) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        const prior = document.getElementsByTagName('script')[0]
        script.async = asyncLoad
        script.defer = defer
        script.addEventListener('load', () => resolve())
        script.addEventListener('error', () => reject(new Error('Loading script')))
        script.src = source
        prior.parentNode.insertBefore(script, prior)
    })
}



// WEBPACK FOOTER //
// ./node_modules/nespresso-library/src/utils/getScript.js